import React, { Component } from 'react';

class SelecionarEscola extends Component {
    constructor(props) {
        super(props)
        this.onChange = this.onChange.bind(this)
    }

    onChange(event) {
        if (this.props.onChange) this.props.onChange(this.props.escolas[event.target.selectedIndex])
    }

    render() {
        // console.log('this.props.selected',this.props.selected)
        return (
            <div>
                <span className="edb-margin-right">Escola: </span>
                <select className="edb-select edb-round-large edb-padding edb-reset-width edb-block-mobile adap-text-darkergray" onChange={this.onChange} value={this.props.selected && this.props.selected.idEntitySchool} >
                    {this.props.escolas.length === 0 && <option>Carregando escolas...</option>}
                    {this.props.escolas.map((item, index) =>
                        <option key={`sel-escola-${index}`} value={item.idEntitySchool}>{item.txBrandName}</option>
                    )}
                </select>
            </div>
        );
    }
}

export default SelecionarEscola
